import React from 'react'
import cx from 'classnames'

import { Image } from 'src/components/image'
import { RenderModules } from 'src/utils/renderModules'
import { SEO } from 'src/components/seo'
import {
  generateMedicalSchema,
  MedicalSchemaProps,
} from 'src/components/schema'

import { ButtonBlock } from 'src/components/inline/buttonBlock'
import Content from 'src/components/content'

export interface ServiceProps {
  pageContext: {
    main: {
      modules: []
      slug: {
        current: string
      }
      title: string
      shortDescription: string
      serviceImage: {
        asset: {
          _id: string
        }
      }
      backgroundColor?: string
      appointmentLink?: any
      showDefaultHero: boolean
      showToc?: boolean
    }
    meta: {}
    env: 'production' | 'development' | 'local' | 'staging'
    pagePath?: string
  }
  path: string
}

const Service = ({ path, pageContext }: ServiceProps) => {
  const {
    main: {
      title,
      appointmentLink,
      shortDescription,
      serviceImage,
      backgroundColor,
      modules,
      showDefaultHero,
      showToc,
      slug,
    },
    meta,
    env,
  } = pageContext

  const pagePath = pageContext.pagePath || path
  const url = pagePath.replace(/^\/+/, '')

  const showDefaultHeroModified =
    showDefaultHero === undefined ? true : showDefaultHero

  const schema = generateMedicalSchema(({
    ...pageContext.main,
    description: shortDescription,
    pagePath,
    schemaKind: 'medicalCategory',
  } as unknown) as MedicalSchemaProps)

  return (
    <div
      className={cx('service', backgroundColor, {
        bcotint: backgroundColor === undefined,
      })}
    >
      <SEO metaInfo={meta} pagePath={url} env={env} schema={schema} />
      {showDefaultHero ? (
        <div className="container--l f jcb aic fw mxa outer p1 pym">
          <Image
            className="x col-m-4"
            imageId={serviceImage.asset._id}
            alt={title}
          />
          <div className="x col-m-6">
            <h1 className="h2">{title} at Tia</h1>
            <p className="ss18 sm25">{shortDescription}</p>
            {appointmentLink && <ButtonBlock data={appointmentLink} />}
            <div className="mt1">
              <a
                href={`${process.env.GATSBY_WIDGET_URL?.split('/signup')[0]}`}
                className="underline o5"
              >
                Already a Tia member? Book here
              </a>
            </div>
          </div>
          <div className="mt1 x">
            <div
              className="cta__squiggle service black mt1 x"
              style={{ backgroundImage: 'url(/squiggle-black.png)' }}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      <Content modules={modules} showToc={showToc}></Content>
    </div>
  )
}

export default Service
